import { combineReducers } from 'redux';
import { connectRouter } from "connected-react-router";

import profile from './model/profile/profile-reducers';

const IndexReducer = (history) => combineReducers({
  profile,

  router: connectRouter(history)
});

export default IndexReducer;